// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
import BaoDialog from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import finitoService from "./../../services/finito-service";
import InstructionShiftbookDialog from "./../dialogs/instruction-shiftbook-dialog";
import AppTabController from "../../services/app-tab-controller";

function InformationLinkedItems(infoVM, tabPage) {
    var self = this;
    self.TabPage = tabPage;
    self.InfoVM = ko.observable(infoVM);
    self.ShiftReportTabController = ko.unwrap(self.InfoVM).TabPage.$TabController;
    self.SessionTabId = infoVM.SessionTabId;
    self.Models = ko.observableArray([]);
    self.CustomFilter = ko.observable({});
    self.Sorting = ko.observableArray([]);
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.SelectedLinkedItem = ko.observableArray([]);
    self.SelectedSearchDialogItemToLink = ko.observable();
    self.ToolbarBtns = ko.observableArray();
    self.OriginalTabTitle = self.TabPage.Title();
    self.TotalRows.subscribe(function (value) {
        if (value == null || value == 0) {
            self.TabPage.Title(self.OriginalTabTitle);
            return;
        }
        self.TabPage.Title(self.OriginalTabTitle + " (" + value + ")");
    });
    tabPage.IconLeft("fal fa-link");
    self.TabPage.DirtyFlag.subscribe(function () {
        if (ko.unwrap(self.TabPage.DirtyFlag)) {
            ko.unwrap(self.InfoVM).TabPage.DirtyFlag(true);
        }
    });
    self.ToolbarBtns.subscribe(function () {
        self.toggleToolbarButton();
    });
    self.SelectedSearchDialogItemToLink.subscribe(function (data) {
        self.LinkItem(ko.unwrap(ko.unwrap(data).Id));
    });
    self.SelectedLinkedItem.subscribe(function () {
        self.toggleToolbarButton();
    });
    self.InfoVM().TabPage.Title.subscribe(function () {
        self.init().then(function () {
            self.toggleToolbarButton();
            self.TabPage.IsLoading(false);
        });
    });
    self.toggleToolbarButton = function () {
        var refreshAllowed = true;
        var addItems = true;
        var remItem = true;
        if (ko.unwrap(ko.unwrap(self.InfoVM).SaveAllowed) !== true) {
            addItems = remItem = refreshAllowed = false;
        }
        else {
            if (ko.unwrap(self.SelectedLinkedItem) == false || ko.unwrap(self.SelectedLinkedItem).length == 0) {
                remItem = false;
            }
        }
        if (ko.unwrap(ko.unwrap(self.InfoVM).IsNew) === true) {
            refreshAllowed = false;
        }
        ko.utils.arrayForEach(self.ToolbarBtns(), function (item: any) {
            if (item.ActionKey() == "ChainedItemsNewInstruction" || item.ActionKey() == "ChainedItemsNewTask" || item.ActionKey() == "ChainedItemsLinkObject") {
                item.Enabled(addItems);
            }
            else if (item.ActionKey() == "ChainedItemsUnlinkItem") {
                item.Enabled(remItem);
            }
            else if (item.ActionKey() == "ChainedItemsRefresh") {
                item.Enabled(refreshAllowed);
            }
        });
    };
    self.toolbarButtonClicked = function (btn) {
        var actionKey = ko.unwrap(btn.ActionKey);
        switch (actionKey) {
            case "ChainedItemsNewInstruction":
                self.CreateNewInstruction();
                break;
            case "ChainedItemsNewTask":
                self.CreateNewTask();
                break;
            case "ChainedItemsLinkObject":
                self.LinkExistingItem();
                break;
            case "ChainedItemsUnlinkItem":
                self.UnlinkItem();
                break;
            case "ChainedItemsRefresh":
                self.Refresh();
                break;
        }
    };
    self.CreateNewTask = function () {
        if (self.InfoVM().TabPage.IsDirty() || self.InfoVM().TabPage.IsNew) {
            var saveInfo = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSavedInfo"), "info");
            return;
        }
        var tbPage = self.InfoVM().TabPage;
        tbPage.IsLoading(true);
        window.baorequire(["ViewModels/Dialogs/InstructionShiftbookDialog"], function (vm) {
            var dialog = new vm(tbPage, "Task");
            dialog.OpenDialog();
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == true) {
                    var selectedShiftbookId = dialog.SelectedItem().ShiftbookId;
                    self.InfoVM().ShiftbookId = selectedShiftbookId;
                    var newTab = new TabPage();
                    newTab.Url("Task/index");
                    newTab.UrlData({
                        id: null,
                        linkFn: self.LinkItem.bind(self),
                        InfoModel: self.InfoVM
                    });
                    AppTabController.AddTab(newTab);
                }
            });
        });
    };
    self.CreateNewInstruction = function () {
        if (self.InfoVM().TabPage.IsDirty() || self.InfoVM().TabPage.IsNew) {
            var saveInfo = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNotSavedInfo"), "info");
            return;
        }
        var tbPage = self.InfoVM().TabPage;
        window.baorequire(["ViewModels/Dialogs/InstructionShiftbookDialog"], function (vm) {
            var dialog = new vm(tbPage, "Instruction");
            dialog.OpenDialog();
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == true) {
                    var selectedShiftbookId = dialog.SelectedItem().ShiftbookId;
                    self.InfoVM().ShiftbookId = selectedShiftbookId;
                    var newTab = new TabPage();
                    newTab.Url("Instruction/index");
                    newTab.UrlData({
                        id: null,
                        linkFn: self.LinkItem.bind(self),
                        InfoModel: self.InfoVM
                    });
                    AppTabController.AddTab(newTab);
                }
            });
        });
    };
    self.LinkExistingItem = function () {
        self.showLinkInfoSearchDialog();
    };
    self.LinkItem = function (linkedItemId) {
        self.TabPage.IsLoading(true);
        return Bao.post("InformationLinkedItems/LinkItem", JSON.stringify({
            sessionTabId: ko.unwrap(ko.unwrap(self.InfoVM).SessionTabId),
            linkedItemId: ko.unwrap(linkedItemId)
        })).then(function () {
            self.TabPage.DirtyFlag(true);
            return self.refreshGrid();
        }).always(function () {
            self.TabPage.IsLoading(false);
        });
    };
    self.UnlinkItem = function () {
        var item = ko.unwrap(self.SelectedLinkedItem);
        if (item == false || !(item.length > 0)) {
            return;
        }
        self.TabPage.IsLoading(true);
        return Bao.post("InformationLinkedItems/UnlinkItem", JSON.stringify({
            sessionTabId: ko.unwrap(ko.unwrap(self.InfoVM).SessionTabId),
            linkedItemId: ko.unwrap(item[0].Id)
        })).then(function () {
            self.TabPage.DirtyFlag(true);
            return self.refreshGrid();
        }).always(function () {
            self.TabPage.IsLoading(false);
        });
    };
    self.ResetSessionTabId = function () {
        self.TabPage.IsLoading(true);
        return Bao.post("InformationLinkedItems/ResetLinkedItems", JSON.stringify({
            sessionTabId: ko.unwrap(ko.unwrap(self.InfoVM).SessionTabId)
        })).always(function () {
            self.TabPage.IsLoading(false);
        });
    };
    self.shouldSave = function () {
        var deferred = $.Deferred();
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.SaveCheck), "question");
        dialog.DialogResult.subscribe(function (saveInformation) {
            deferred.resolve(saveInformation);
        });
        return deferred.promise();
    };
    self.Save = function () {
        self.TabPage.IsLoading(true);
        return Bao.post("InformationLinkedItems/SaveLinkedItems", JSON.stringify({
            infoId: ko.unwrap(ko.unwrap(self.InfoVM).InfoId),
            sessionTabId: ko.unwrap(ko.unwrap(self.InfoVM).SessionTabId)
        })).always(function () {
            self.TabPage.DirtyFlag(false);
            self.TabPage.IsLoading(false);
        });
    };
    self.showLinkInfoSearchDialog = function () { };
    self.refreshGrid = function () {
        return Bao.post("InformationLinkedItems/GetAllLinkedItems", JSON.stringify({
            sessionTabId: ko.unwrap(ko.unwrap(self.InfoVM).SessionTabId),
            infoid: ko.unwrap(ko.unwrap(self.InfoVM).InfoId),
            sorter: ko.unwrap(self.Sorting),
            pageIndex: ko.unwrap(self.PageIndex),
            pageSize: ko.unwrap(self.PageSize)
        })).done(function (data) {
            self.TotalRows(data.total);
            ko.map.fromJS(data.data, self.Models);
        });
    };
    self.Refresh = function () {
        var def;
        if (self.TabPage.DirtyFlag() && ko.unwrap(ko.unwrap(self.InfoVM).SaveAllowed) === true) {
            def = self.shouldSave();
        }
        else {
            def = $.Deferred().resolve(false);
        }
        return def.then(function (shouldSave) {
            if (shouldSave === true) {
                return self.Save();
            }
            else if (shouldSave === null) {
                return $.Deferred().reject();
            }
            return true;
        }).then(function () {
            self.TabPage.IsLoading(true);
            return self.ResetSessionTabId().then(self.refreshGrid).done(function () {
                self.TabPage.DirtyFlag(false);
                self.TabPage.IsLoading(false);
            });
        });
    };
    self.InfoVM().SubTabsSaveFn.push(self.Save);
    self.init = function () {
        self.TabPage.IsLoading(true);
        return self.ResetSessionTabId()
            .then(_ => self.refreshGrid());
    };
    self.loaded = function () {
        self.Sorting.subscribe(function () {
            self.refreshGrid();
        });
        self.PageIndex.subscribe(function () {
            self.refreshGrid();
        });
        self.TabPage.IsLoading(false);
    };
    self.SetPermissions = function (showBtnsFn) {
        var permissions = self.InfoVM().ShiftReport.Permissions();
        if (!permissions)
            return;
        for (var actionKey in permissions) {
            if (self.baoToolbar2LinkItemsShowButton) {
                self.baoToolbar2LinkItemsShowButton(actionKey, permissions[actionKey]);
            }
        }
    };
}
export default InformationLinkedItems;